import { createStorageValue } from '@interhyp/platform-storage';
import { z } from 'zod';
import { configurationNamespace } from '../namespaces';
import { configurationDefinitionSchema } from './configTypes';
// currently cached configuration definitions
export const cachedConfigurationDefinitions = createStorageValue({
    namespace: configurationNamespace,
    id: Symbol('configurationDefinitions'),
    schema: z.array(configurationDefinitionSchema),
    type: 'local',
});
// time to live for currently cached configuration definitions
export const configurationDefinitionsCachingTime = createStorageValue({
    namespace: configurationNamespace,
    id: Symbol('configurationDefinitionsTimeToLive'),
    schema: z.number(),
    type: 'local',
});
